
import appHelpers from "../common/helpers/appHelpers";
import { getUserIdentity } from "../common/helpers/authorizationHelper";
import { isLogoAppProject } from "../common/helpers/globalHelpers";
import { AuthenticationTypes, UserOperationTypes } from "../common/types/AuthorizationProps";





export interface MenuItemTypes {
  key: string;
  label: string;
  isTitle?: boolean;
  icon?: string;
  url?: string;
  parentKey?: string;
  target?: string;
  children?: MenuItemTypes[];
  className?: string;
  isPortalMenu?: boolean;
  isSabeeAppMenu?: boolean;
  isErpFirmAccess?: boolean,
  authorizationTypes?: UserOperationTypes[],
  adminAuthorizationTypes?: UserOperationTypes[],
  authenticationTypes?: AuthenticationTypes[],
  isAdiminAccess?: boolean,
  isFooter?: boolean,
};
const isLogoApp = isLogoAppProject();
const platform = appHelpers.getPlatform();
const userIdentity = getUserIdentity();



const MENU_ITEMS: MenuItemTypes[] = [
  {
    key: 'menu',
    label: 'Menü',
    isTitle: true,
  },
  {
    key: 'anasayfa',
    label: 'Ana Sayfa',
    isTitle: false,
    icon: '/icons/anasayfa.svg',
    url: '/dashboard',

  },
  {
    key: 'rezervasyon-listesi',
    label: 'Rezervasyon Listesi',
    isTitle: false,
    icon: '/icons/rezervasyon-listesi.svg',
    url: '/rezervasyon-listesi',
    isPortalMenu: true,
    isSabeeAppMenu: true,

  },
  {
    key: 'odeme-sayfasi',
    label: 'Ödeme Sayfası',
    isTitle: false,
    icon: '/icons/odeme-sayfasi.svg',
    url: '/odeme-sayfasi',
    authorizationTypes: [UserOperationTypes["Ödeme Al"]]
  },
  {
    key: 'musteri-listesi',
    label: 'Müşteri Listesi',
    authenticationTypes: ["ADMIN", "FİRMA YETKİLİSİ"],
    isTitle: false,
    icon: '/icons/musteri-listesi.svg',
    url: '/musteri-listesi',
    isPortalMenu: true,
    authorizationTypes: [UserOperationTypes["Müşteri Listesi"],],
    isAdiminAccess: true
  },
  {
    key: 'islem-raporu',
    label: 'Tahsilat Hareketleri',
    isTitle: false,
    icon: '/icons/islem-raporu.svg',
    url: '/islem-raporu',
    authorizationTypes:[UserOperationTypes["İşlem Listesi"]]
  },
  {
    key: 'odeme-linki',
    label: 'Ödeme Linki',
    isTitle: false,
    icon: '/icons/serbest-odeme-baslat.svg',
    authorizationTypes: [UserOperationTypes["Ödeme Linki Gönder"], UserOperationTypes["Serbest Ödeme Al"]],
    children: [
      {
        key: 'toplu-odeme-baslat',
        label: 'Toplu Ödeme Başlat',
        parentKey: 'odeme-linki',
        url: '/toplu-odeme-baslat',
        isAdiminAccess: true
      },
      {
        key: 'serbest-odeme-baslat',
        label: 'Serbest Ödeme Başlat',
        url: '/serbest-odeme-baslat',
        parentKey: 'odeme-linki',
        authorizationTypes: [UserOperationTypes["Ödeme Linki Gönder"]],
        adminAuthorizationTypes: [UserOperationTypes["Ödeme Al"], UserOperationTypes["Serbest Ödeme Al"]],
      },
      {
        key: 'suresiz-odeme-linki',
        label: 'Süresiz Ödeme Linki',
        parentKey: 'odeme-linki',
        url: '/suresiz-odeme-linki',
        // authorizationTypes:[UserOperationTypes["Serbest Ödeme Al"]]
        isAdiminAccess: true
      },
      {
        key: 'gonderilen-odeme-linkleri',
        label: 'Gönderilen Ödeme Linkleri',
        url: '/gonderilen-odeme-linkleri',
        parentKey: 'odeme-linki',
        authenticationTypes: ["ADMIN", "FİRMA YETKİLİSİ"],
        isAdiminAccess: userIdentity == "FİRMA YETKİLİSİ" ? true : false || true,
      },
    ]
  },
  {
    key: 'kullanicilar',
    label: 'Kullanıcılar',
    isPortalMenu: true,
    isTitle: false,
    icon: '/icons/kullanicilar.svg',
    authenticationTypes: ["ADMIN", "FİRMA YETKİLİSİ"],
    authorizationTypes: [UserOperationTypes["Kullanıcı İşlemleri"]],
    children: [
      {
        key: 'kullanici-listesi',
        label: 'Kullanıcı Listesi',
        // icon: '',
        parentKey: 'kullanicilar',
        url: '/kullanici-listesi',
      },
      {
        key: 'kullanici-musteri-yetkilendir',
        label: 'Kullanıcı Müşteri Yetkilendir',
        url: '/kullanici-musteri-yetkilendir',
        parentKey: 'kullanicilar',
        // icon: '',
      },
    ]
  },
  {
    key: 'tahsilat-mutabakati',
    label: isLogoApp ? (platform === "NETSIS" ? "Netsis ERP Fiş Aktarımı" : "Logo ERP Fiş Aktarımı") : "ERP Fiş Aktarımı",
    isTitle: false,
    icon: '/icons/tahsilat-mutabakati.svg',
    url: '/tahsilat-mutabakati',
    isErpFirmAccess: true,
    authenticationTypes: ["ADMIN", "FİRMA YETKİLİSİ"],
    authorizationTypes: [UserOperationTypes["Erp Entegrasyonu"]],
  },
  {
    key: 'zamanlanmis-gorevler-menu',
    label: "Zamanlanmış Görevler",
    isPortalMenu: true,
    isTitle: false,
    icon: '/icons/zamanlanmis-gorevler.svg',
    isErpFirmAccess: true,
    authenticationTypes: ["ADMIN", "FİRMA YETKİLİSİ"],
    authorizationTypes: [UserOperationTypes["Erp Entegrasyonu"]],
    children: [
      {
        key: 'zamanlanmis-gorev-tanimi',
        label: "Görev Tanımı",
        isTitle: false,
        url: '/zamanlanmis-gorev-tanimi',
        parentKey: 'zamanlanmis-gorevler-menu',
      },
      {
        key: 'zamanlanmis-gorevler',
        label: "Görev Kayıtları",
        isTitle: false,
        url: '/zamanlanmis-gorevler',
        parentKey: 'zamanlanmis-gorevler-menu',
      }
    ]
  },
  {
    key: 'pos-baglanti-ayarlari',
    label: 'POS Entegrasyonları',
    isTitle: false,
    icon: '/icons/link.svg',
    url: '/pos-baglanti-ayarlari',
    isAdiminAccess: true
  },
  {
    key: 'odeme-setleri',
    label: 'Ödeme Kuralı Listesi',
    isTitle: false,
    icon: '/icons/payment-sets-blue.svg',
    url: '/odeme-setleri',
    isAdiminAccess: true
  },
  {
    key: 'parametreler',
    label: 'Ayarlar',
    isTitle: false,
    icon: '/icons/parameters.svg',
    url: '/parametreler',
    isAdiminAccess: true
  },
  // {
  //   key: 'geri-odeme-raporlari',
  //   label: 'Geri Ödeme Raporları',
  //   isTitle: false,
  //   icon: '/icons/geri-odeme-raporlari.svg',
  //   url: '/geri-odeme-raporlari',
  //   isAdiminAccess: true
  // },
  {
    key: 'bize-ulasin',
    label: 'Bize Ulaşın',
    isTitle: false,
    icon: '/icons/contact-us.svg',
    url: 'https://www.elogo.com.tr/destek/#saform',
    target: '_blank',
    isFooter: true
  },
];

export { MENU_ITEMS };
